export { ReportPostCard } from './ReportPostCard'
